export const lightTheme = {
  "common.backgroundColor": "#ffffff",
  "header.backgroundColor": "#ffffff",
  "menu.backgroundColor": "#ffffff",
  "submenu.backgroundColor": "#ffffff",
  "submenu.partition.color": "#ddd",
  "menu.normalLabel.color": "#2d31a6",
  "menu.activeLabel.color": "#2d31a6",
  "menu.hoverLabel.color": "#444ce7",
  "submenu.normalLabel.color": "#2d31a6",
  "submenu.activeLabel.color": "#2d31a6",
  "submenu.hoverLabel.color": "#444ce7",
  "button.backgroundColor": "#2d31a6",
  "button.color": "#ffffff",
  "icon.color": "#2d31a6",
  "icon.active.color": "#444ce7",
  "icon.hover.color": "#2d31a6",
  "mask.color": "rgba(0,0,0,0.3)",
};

// Dark theme
export const darkTheme = {
  "common.backgroundColor": "#1a1a1a",
  "header.backgroundColor": "#2c2c2c",
  "menu.backgroundColor": "#2c2c2c",
  "submenu.backgroundColor": "#2c2c2c",
  "submenu.partition.color": "#444",
  "menu.normalLabel.color": "#22ccee",
  "menu.activeLabel.color": "#67e3f9",
  "menu.hoverLabel.color": "#22ccee",
  "submenu.normalLabel.color": "#22ccee",
  "submenu.activeLabel.color": "#67e3f9",
  "submenu.hoverLabel.color": "#22ccee",
  "button.backgroundColor": "#22ccee",
  "button.color": "#1a1a1a",
  "icon.color": "#22ccee",
  "icon.active.color": "#67e3f9",
  "icon.hover.color": "#22ccee",
  "mask.color": "rgba(255,255,255,0.3)",
};
